import type { FC, ReactNode } from "react"
import { useTranslation } from "react-i18next"

import { HoverPopover } from "@/nzds/feedback/hover-popover"

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import IconButton from "@mui/material/IconButton"

interface FieldTooltipProps {
  content: ReactNode
  tabIndex?: number
}

export const FieldTooltip: FC<FieldTooltipProps> = ({
  content,
  tabIndex = 0,
}) => {
  const { t } = useTranslation("common")

  return (
    <HoverPopover content={content}>
      <IconButton
        aria-label={t("button.moreInformation")}
        color="neutral"
        size="small"
        sx={{
          height: (theme) => theme.typography.pxToRem(24),
          minHeight: (theme) => theme.typography.pxToRem(24),
          minWidth: (theme) => theme.typography.pxToRem(24),
          width: (theme) => theme.typography.pxToRem(24),
        }}
        tabIndex={tabIndex}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </HoverPopover>
  )
}
